import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { confirmationDigitsCodeValidator, userEmailValidator, } from '#validation';
const initiateAccountRecoverySchema = z.object({
    email: userEmailValidator,
});
export class InitiateAccountRecoveryDto extends createZodDto(initiateAccountRecoverySchema) {
}
const accountRecoveryEmailVerificationSchema = z.object({
    email: userEmailValidator,
    verificationCode: confirmationDigitsCodeValidator({
        requiredError: 'emailVerification.code.required',
        lengthError: 'emailVerification.code.length',
    }),
});
export class AccountRecoveryVerificationDto extends createZodDto(accountRecoveryEmailVerificationSchema) {
}
export { UserIdentityDto } from '../identity';
export { UserCryptoDto } from '../identity';
